// extracted by mini-css-extract-plugin
module.exports = {"titleBar":"header-module--title-bar--rMgZU","logo":"header-module--logo--a2tog","title":"header-module--title--3pkpp","author":"header-module--author--Pa1m6"};